(function () {
  if (!window.location.pathname.includes('/products/fromage-a-raclette')) return;

  var CHARCUTERIE = [
    { name: 'Saucisson géant', variantId: 54482663407944, price: 8.00 },
    { name: 'Coppa', variantId: 54482663440712, price: 6.00 },
    { name: 'Pancetta', variantId: 54482663473480, price: 6.00 },
    { name: 'Jambon fumé', variantId: 54482663539016, price: 6.00 },
    { name: 'Bacon', variantId: 54482663637320, price: 6.00 }
  ];

  function formatPrice(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function buildModal() {
    var overlay = document.createElement('div');
    overlay.id = 'raclette-popup-overlay';
    overlay.innerHTML =
      '<div id="raclette-popup">' +
      '  <button type="button" id="raclette-popup-close" aria-label="Fermer">&times;</button>' +
      '  <div id="raclette-popup-step-question">' +
      '    <h3>Avez-vous prévu la charcuterie ?</h3>' +
      '    <div class="raclette-popup-buttons">' +
      '      <button type="button" id="raclette-popup-no-thanks" class="raclette-popup-btn raclette-popup-btn--secondary">Oui, c\'est bon, j\'ai déjà</button>' +
      '      <button type="button" id="raclette-popup-yes-please" class="raclette-popup-btn raclette-popup-btn--primary">Non, pas encore, j\'en veux !</button>' +
      '    </div>' +
      '  </div>' +
      '  <div id="raclette-popup-step-charcuterie" hidden>' +
      '    <h3>Choisissez votre charcuterie</h3>' +
      '    <ul id="raclette-popup-charcuterie-list"></ul>' +
      '    <button type="button" id="raclette-popup-done" class="raclette-popup-btn raclette-popup-btn--primary">J\'ai terminé, passer commande</button>' +
      '  </div>' +
      '  <div id="raclette-popup-step-loading" hidden><p>Ajout au panier…</p></div>' +
      '</div>';
    document.body.appendChild(overlay);

    var list = overlay.querySelector('#raclette-popup-charcuterie-list');
    CHARCUTERIE.forEach(function (item, index) {
      var li = document.createElement('li');
      li.className = 'raclette-popup-charcuterie-item';
      li.innerHTML =
        '<span class="raclette-popup-charcuterie-name">' + item.name + ' <small>(' + formatPrice(item.price) + ')</small></span>' +
        '<span class="raclette-popup-stepper">' +
        '  <button type="button" class="raclette-popup-stepper-btn" data-action="minus" data-index="' + index + '">−</button>' +
        '  <span class="raclette-popup-qty" data-qty-index="' + index + '">0</span>' +
        '  <button type="button" class="raclette-popup-stepper-btn" data-action="plus" data-index="' + index + '">+</button>' +
        '</span>';
      list.appendChild(li);
    });

    return overlay;
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('add to cart failed');
      return res.json();
    });
  }

  function init() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var overlay = null;
    var quantities = CHARCUTERIE.map(function () { return 0; });

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (!overlay) overlay = buildModal();
        quantities = CHARCUTERIE.map(function () { return 0; });
        overlay.querySelectorAll('[data-qty-index]').forEach(function (el) { el.textContent = '0'; });
        overlay.querySelector('#raclette-popup-step-question').hidden = false;
        overlay.querySelector('#raclette-popup-step-charcuterie').hidden = true;
        overlay.querySelector('#raclette-popup-step-loading').hidden = true;
        overlay.style.display = 'flex';

        var variantId = form.querySelector('input[name="id"]').value;
        var qtyInput = form.querySelector('input[name="quantity"]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        function finishWithCheese(extraItems) {
          overlay.querySelector('#raclette-popup-step-question').hidden = true;
          overlay.querySelector('#raclette-popup-step-charcuterie').hidden = true;
          overlay.querySelector('#raclette-popup-step-loading').hidden = false;
          var items = [{ id: variantId, quantity: quantity }].concat(extraItems);
          addToCart(items)
            .then(function () { window.location.href = '/cart'; })
            .catch(function () {
              overlay.querySelector('#raclette-popup-step-loading').hidden = true;
              alert("Une erreur est survenue, merci de réessayer.");
            });
        }

        overlay.querySelector('#raclette-popup-close').onclick = function () {
          overlay.style.display = 'none';
        };
        overlay.querySelector('#raclette-popup-no-thanks').onclick = function () {
          finishWithCheese([]);
        };
        overlay.querySelector('#raclette-popup-yes-please').onclick = function () {
          overlay.querySelector('#raclette-popup-step-question').hidden = true;
          overlay.querySelector('#raclette-popup-step-charcuterie').hidden = false;
        };
        overlay.querySelectorAll('.raclette-popup-stepper-btn').forEach(function (btn) {
          btn.onclick = function () {
            var i = parseInt(btn.getAttribute('data-index'), 10);
            var action = btn.getAttribute('data-action');
            quantities[i] = Math.max(0, quantities[i] + (action === 'plus' ? 1 : -1));
            overlay.querySelector('[data-qty-index="' + i + '"]').textContent = quantities[i];
          };
        });
        overlay.querySelector('#raclette-popup-done').onclick = function () {
          var extraItems = [];
          CHARCUTERIE.forEach(function (item, i) {
            if (quantities[i] > 0) extraItems.push({ id: item.variantId, quantity: quantities[i] });
          });
          finishWithCheese(extraItems);
        };
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
